<template>
  <StepModel
    :ui="uiBaseStep"
    :name="STEP_NAMES.identityReviewDigital"
    ui-title=""
    ui-subtitle=""
    ui-error-message="Please review the fields marked in red"
    ui-button-text="Submit"
     
  >
  <!-- <FieldsetModel :ui="uiBaseFieldset" name="fieldSetStep8" ui-title="" >
       
      </FieldsetModel> -->
  <FieldsetModel :ui="uiBaseFieldset" name="fieldSetIndentityReview" >
      <p style="color: #6e3dea;
  font-weight: 500;
  font-size: 30px;padding-bottom:20px">Have we got your details right?</p>
   <p style="
  font-weight: 500;
  font-size: 20px">We just need a couple of details to move ahead.</p>
  <p style="color: #6e3dea;">*Please verify the details and edit if required.</p>
  
  </FieldsetModel>
    <!-- ui-secondary-button="Edit"
    :ui-secondary-action="editFields" -->
   
   <!-- <FieldsetEmiratesIdNumber /> -->
   
    <FieldsetModel
      :ui="uiBaseFieldset"
      :name="FIELDSET_NAMES.emiratesIdExpiryDate"
      :ui-columns="columns"
   
    >
     <UiWrapper
      :name="FIELD_NAMES.emiratesID"
      label="Emirates ID No."
      :validations="emiratesIdValidation"
    >
      <InputText
        type="tel"
        :maxlength="15"
      />
    </UiWrapper>
      <UiWrapper
        :name="FIELD_NAMES.expiryDate"
        label="Expiry date"
        :validations="[
          {
            'errorMessage': 'Please type a future date',
            'condition': isFutureDateCondition,
            'name': 'expirydate-is-futuredate',
          },
        ]"
      >
        <DateWrapper />
      </UiWrapper>
    </FieldsetModel>
     <FieldsetModel
      :ui="uiBaseFieldset"
      :name="FIELDSET_NAMES.nationality"
    
     :ui-columns="columns"
    >
      <UiWrapper
        :name="FIELD_NAMES.nationality"
        label="Nationality"
        :validations="[
          {
            'errorMessage': 'This field must not be empty',
            'condition': notEmptyCondition,
            'name': 'nationality-filled',
          },
        ]"
      >
        <Suggest
          :exact-match="true"
          placeholder="Select your nationality"
          :get-formatted-item="formatMatchedString"
          :get-suggestions="getCountries"
        />+
      </UiWrapper>
      <UiWrapper
        :name="FIELD_NAMES.birthDate"
        label="Date of birth"
        :validations="dobValidations"
        
      >
        <DateWrapper />
      </UiWrapper>
    </FieldsetModel>
    <!-- <FieldsetBornDate
      :name="FIELDSET_NAMES.bornDateReview"
      title="Date of birth"
      label="Date of birth"
      :presence="showNameFields"
    /> -->
     <FieldsetFullName title="Preferred name on Card (Cardholder's name)" />
<FieldsetModel
        :ui="uiBaseFieldset"
        :name="FIELDSET_NAMES.passportNumberFieldSet"
       title="Enter your Passport Number"
        
      >
        <UiWrapper
          :name="FIELD_NAMES.passportNumber"
          label="Passport number"
         
          :validations="[
              {
                'errorMessage': 'Please type a valid passport',
                'condition': patternCondition(ALPHA_NUMERIC),
                'name': 'check-is-passport',
              },
            ]"
        >
          <InputText  />
        </UiWrapper>
        <!-- <UiWrapper
            :name="FIELD_NAMES.uAESince"
            label="You have been in UAE since"
            :validations="[
              {
                errorMessage: 'Please type a past date',
                condition: isPastDateCondition,
                name: 'birth-is-pastdate',
              },
              {
                errorMessage: 'Please enter a valid date',
                condition: isValidDateCondition,
                name: 'is-valid-date',
              },
            ]"
          >
            <DateWrapper />
          </UiWrapper> -->
      </FieldsetModel>
     
      <FieldsetModel
          :ui="uiBaseFieldset"
          :name="FIELDSET_NAMES.living"
          ui-title="You have lived in the UAE for"
        >
          <UiWrapper :name="FIELD_NAMES.livingTime">
            <Dropdown
              placeholder="Months"
              :options="[
                { value: '0-5 Months', label: '0-5 Months' },
                { value: '6-11 Months', label: '6-11 Months' },
                { value: '12-17 Months', label: '12-17 Months' },
                { value: '18-23 Months', label: '18-23 Months' },
                { value: '24-35 Months', label: '24-35 Months' },
                { value: '36-47 Months', label: '36-47 Months' },
                { value: '48-59 Months', label: '48-59 Months' },
                { value: '60-71 Months', label: '60-71 Months' },
                { value: '72+ Months', label: '72+ Months' },
              ]"
            />
          </UiWrapper>
        </FieldsetModel>
  <FieldsetModel :ui="uiBaseFieldset" name="cifErrorFieldSet">
      <p id="cifErrorMessage" ></p>
    </FieldsetModel>

  </StepModel>
</template>

<script>
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
// Components
import UiWrapper from "@/forms/components/base/ui-wrapper";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import FieldsetBornDate from "@/forms/components/shared/fieldsets/born-date";
import FieldsetEmiratesIdNumber from "@/forms/components/shared/fieldsets/emirates-id-number";
import DateWrapper from "@/forms/components/ui-dunia/date-wrapper";
import CheckWrapper from "@/forms/components/ui-dunia/check-wrapper";
import FieldsetFullName from "@/forms/components/shared/fieldsets/full-name";
import * as conditions from '@/forms/conditions';
import { EMIRATES_NUMBER_LENGTH, EMIRATES_STARTING_NUMBER, DIGIT_CHARS, MIN_AGE } from '@/forms/constants/onboarding-logic';
import FIELD_NAMES from "@/forms/constants/field-names";
// Ui Components
import { Suggest, Choice, Expandable, InputText,Dropdown } from "@dunia/ui";

export default {
  components: {
    UiWrapper,
    StepModel,
    FieldsetModel,
    Suggest,
    Choice,
    DateWrapper,
    CheckWrapper,
    FieldsetBornDate,
    FieldsetFullName,
    FieldsetEmiratesIdNumber,
    Expandable,
    InputText,
    Dropdown,
    FIELD_NAMES
  },

  mixins: [FormComponentMixin],
  data: () => ({
    DIGIT_CHARS,
    EMIRATES_STARTING_NUMBER,
    EMIRATES_NUMBER_LENGTH,
    identityReviewTitle: `Great! Your personal
information has been
captured from your
Emirates ID.`,

  
  }),
  props: {
    showNameFields: {
      type: Boolean,
      default: true
    },
    stepTitle: {
      type: String
    },
//     subtitle:{
//  type: String,
//  default:'*Please verify the below details and edit if required.'
//     },
     columns: {
      type: String,
      default: '2',
    },
     emiratesIdValidation: {
      type: Array,
      default: () => ([
        {
          errorMessage: 'Please type a valid number',
          condition: conditions.patternCondition(DIGIT_CHARS),
          name: 'check-is-mobile-only-digits',
        },
        {
          errorMessage: 'Your id must start with a 784',
          condition: conditions.patternCondition(EMIRATES_STARTING_NUMBER),
          name: 'check-is-emirates-starting-number',
        },
        {
          errorMessage: 'Your birth year must follow the 784 digits',
          condition: conditions.emiratesIdHasBirthYear,
          name: 'check-emirates-id-birth-year',
        },
        {
          errorMessage: 'Your id number must have 15 digits',
          condition: conditions.patternCondition(EMIRATES_NUMBER_LENGTH),
          name: 'check-is-emirate-id-length',
        },
      ]),
    },
     dobValidations: {
      type: Array,
      default: () => ([
        {
          errorMessage: 'Please type a past date',
          condition: conditions.isPastDateCondition,
          name: 'birth-is-pastdate',
        },
        // {
        //   errorMessage: 'You must be under 60 years old',
        //   condition: conditions.maxYearCondition(MAX_AGE),
        //   name: 'age-is-under-60',
        // },
        {
          errorMessage: 'You must be at least 21 years old',
          condition: conditions.minYearCondition(MIN_AGE),
          name: 'age-is-above-21',
        },
      ]),
    },
  },
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  methods:{
editFields(){
  alert('asdf');
}
  },
  computed: {
    // subtitle() {
    //   if (this.hasUploadedIDCard) {
    //     return "Check if the below information matches your Emirates ID. If not, please make changes to ensure that they match";
    //   }

    //   return "Enter details exactly as it appears on your Emirates ID";
    // },
    isSalesAgent() {
      let source;
      if (this.$store.state.source) {
        source = this.$store.state.source.toUpperCase();
      }
      if (this.$store.state.employeeCodes || source === "DSA") {
        return true;
      }
    },
    isCifCreated() {
      if (this.$store.state.isCifError) {
        return "An error occured while generating the CIF  number. Please try again by clicking on the below retry button .";
      }
    },
    primaryButtonText() {
      if (this.$store.state.isCifError) {
        return "RETRY";
      } else {
        return "NEXT";
      }
    },
     getDateOfBirth(){
    return  this.$store.state.automationResponse['dateOfBirth'];
  }
  },
  watch: {
    isCifCreated(value) {
      var p = document.getElementById("cifErrorMessage");
      if (p) {
        p.innerHTML = typeof value !== "undefined" ? value : "";
      }
    }
  }
};
</script>
<style scoped>
.consentStyle {
  font-family: "Moderat", serif;
  font-weight: 300;
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0px;
  display: inline;
  color: #9e9e9e;
  cursor: pointer;
}
.c-onboarding > .header .content > .title {
    font-family: "Moderat", serif;
    font-weight: 300;
    font-size: 15px;
    line-height: 28px;
    letter-spacing: 0px;
    color: #6e3dea !important;;
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 72px;
    padding: 0 28px;
}
/* Progess Bar with steps */
.stepper-wrapper {
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.stepper-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 12px;
  }
}

.stepper-item::before {
  position: absolute;
  content: "";
  border-bottom: 3px solid #ccc;
  width: 100%;
  top: 15px;
  left: -50%;
  z-index: 2;
}

.stepper-item::after {
  position: absolute;
  content: "";
  border-bottom: 3px solid #ccc;
  width: 100%;
  top: 15px;
  left: 50%;
  z-index: 2;
}

.stepper-item .step-counter {
  position: relative;
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #ccc;
  margin-bottom: 6px;
}

.stepper-item.active {
  font-weight: bold;
 

}
.step-counter.active{
  background-color: #6e3dea;
}

.stepper-item.completed .step-counter {
  background-color: #6e3dea;
}

.stepper-item.completed::after {
  position: absolute;
  content: "";
  /* border-bottom: 2px solid #6e3dea; */
  width: 100%;
  top: 15px;
  left: 50%;
  z-index: 3;
}

.stepper-item:first-child::before {
  content: none;
}
.stepper-item:last-child::after {
  content: none;
}
</style>
